///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2023 - 2024
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { times } from "lodash";

import CapacityMatchTableHeader from "./CapacityMatchTableHeader";

function CapacityMatchLoading() {
  const BodyCell = () => (
    <td className={"body-cell content-placeholder py-16 px-8 align-middle"}>
      <span></span>
    </td>
  );

  return (
    <table
      className="one-whole capacity-match-grid"
      id="capacity-match-loading"
    >
      <CapacityMatchTableHeader />
      <tbody>
        {times(10, index => (
          <tr className="row bg-white" key={index}>
            {times(18, columnIndex => (
              <BodyCell key={`loading-${index}-${columnIndex}`} />
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export default CapacityMatchLoading;
